"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootArticleDetailAmpReducer = void 0;
var redux_1 = require("redux");
var Pages_1 = require("@/rendering/common/Pages");
var Breadcrumb_init_1 = require("@/pages/articleDetail/states/Breadcrumb.init");
var NewsArticleDetail_init_1 = require("@/pages/articleDetail/states/NewsArticleDetail.init");
var NewsAndInsights_init_1 = require("@/pages/articleDetail/states/NewsAndInsights.init");
var ResultPageState_init_1 = require("@/pages/search/states/ResultPageState.init");
var RootPublicPageReducer_1 = require("@/pages/common/reducers/RootPublicPageReducer");
var articleDetailReducer = {
    page: function (state) {
        if (state === void 0) { state = Pages_1.Pages.NEWS_AND_INSIGHTS_DETAIL; }
        return state;
    },
    nomenu: function (state) {
        if (state === void 0) { state = 0; }
        return state;
    },
    breadcrumb: function (state) {
        if (state === void 0) { state = Breadcrumb_init_1.defaultBreadcrumb; }
        return state;
    },
    newsArticleDetail: function (state) {
        if (state === void 0) { state = NewsArticleDetail_init_1.defaultNewsArticleDetail; }
        return state;
    },
    newsAndInsights: function (state) {
        if (state === void 0) { state = NewsAndInsights_init_1.defaultNewsAndInsights; }
        return state;
    },
    resultPageTranslation: function (state) {
        if (state === void 0) { state = ResultPageState_init_1.defaultResultPageState.t; }
        return state;
    },
};
var combinedReducer = redux_1.combineReducers(__assign(__assign({}, RootPublicPageReducer_1.default), articleDetailReducer));
var rootArticleDetailReducer = function (state, action) {
    if (action.type === 'SET_ALL_STATE_NEWS_AND_INSIGHTS_DETAIL') {
        return __assign(__assign({}, state), action.payload);
    }
    return combinedReducer(state, action);
};
exports.rootArticleDetailAmpReducer = function (state, action) {
    if (action.type === 'SET_ALL_STATE_NEWS_AND_INSIGHTS_DETAIL_AMP') {
        return __assign(__assign({}, state), action.payload);
    }
    return combinedReducer(state, action);
};
exports.default = rootArticleDetailReducer;
